import React from 'react';

const ImageCacheContext = React.createContext();

export default ImageCacheContext;
